import React, { lazy, Suspense, useState } from "react";
import Welcome from "./components/welcomescreen/Welcome";
import Maintenance from "./components/maintenance/Maintenance";
import { HelmetProvider } from "react-helmet-async";
import StripeProvider from "./providers/stripeProvider";
import useSessionRestore from "./hooks/useSessionRestore";

const Routes = lazy(() => import("./routes/routes"));

const App = () => {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const isSessionReady = useSessionRestore();

  return (
    <>
      <StripeProvider>
        <HelmetProvider>
          {maintenanceMode ? (
            <Maintenance />
          ) : !isSessionReady ? (
            <Welcome />
          ) : (
            <Suspense fallback={<Welcome />}>
              <Routes />
            </Suspense>
          )}
        </HelmetProvider>
      </StripeProvider>
    </>
  );
};

export default App;
